<template>
  <header class="w-full border-b">
    <div class="mx-auto flex max-w-wrapper items-center justify-between p-2 px-4">
      <HeaderLogo />

      <!-- 메뉴 -->
      <HeaderNav v-model:open="navOpen" />

      <HeaderUserMenu
        :open="userMenuOpen"
        @toggle-nav="toggleUserMenu"
        @close-nav="userMenuOpen = false"
      />
    </div>
  </header>
</template>

<script setup lang="ts">
import { ref } from "vue";

const navOpen = ref(false);
const userMenuOpen = ref(false);

onMounted(() => {
  const mq = window.matchMedia("(min-width: 1280px)");

  navOpen.value = mq.matches;

  mq.addEventListener("change", (e) => {
    navOpen.value = e.matches;
  });
});

const toggleUserMenu = () => {
  navOpen.value = !navOpen.value;
};
</script>
